module.exports = __webpack_public_path__ + "assets/img/dianhua.0c02f716.png";